import { createUseStyles } from 'react-jss';

const styles = {
  modalSpacing: {
    padding: '2.4rem 6.4rem 4rem 6.4rem',
  },
  body: {
    font: {
      family: 'Lato, sans-serif',
    },
    width: '100%',
  },
  form: { position: 'relative' },
  textAreaName: {
    textTransform: 'uppercase',
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      fontWeight: 500,
      letterSpacing: '0.05rem',
    },
  },
  footer: {
    margin: [0],
    marginTop: '0.4rem',
    padding: { top: '4rem' },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actionsBlock: {
    margin: [0],
    width: '42.4rem',
    display: 'flex',
    alignItems: 'center',
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
